export const storeInfo = {
  name: "Lounge狼月",
  nameEn: "ROUGETSU",
  phone: "0853-31-7066",
  address: "〒693-0001 島根県出雲市今市町1448 アークビル第3ビル2階",
  hours: {
    open: "20:00〜25:00",
    closed: "水曜日",
  },
  seats: {
    total: 20,
    counter: 4,
    table: "4名掛け×4テーブル",
  },
  instagram: "@lounge_rougetu",
  instagramUrl: "https://www.instagram.com/lounge_rougetu/",
  concept: "みんなが楽しめるお店、アットホーム",
  conceptDetail:
    "月と狼をモチーフにした、大人のための隠れ家ラウンジ。\n落ち着いた空間で、日常を忘れて特別な時間をお過ごしください。\n一人でも、大切な人とでも、誰もが心地よく過ごせる場所を目指しています。",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3254.876968300785!2d132.754722!3d35.366944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCMjInMDAuNiJOIDEzMsKwNDUnMTcuMCJF!5e0!3m2!1sja!2sjp!4v1710000000000!5m2!1sja!2sjp",
};

export const pricing = {
  setLabel: "1セット",
  duration: "60分",
  men: 3500,
  women: 2500,
  note: "※各種カード・電子マネーご利用いただけます",
};

export const includedDrinks = [
  "焼酎",
  "ウイスキー",
  "ブランデー",
  "梅酒",
  "酎ハイ",
  "カクテル",
];

export const draftBeerAddon = {
  label: "生ビール飲み放題",
  price: 1000,
};

export const bottleKeep = {
  label: "ボトルキープ",
  duration: "90分",
  men: 3500,
  women: 2500,
};

export const recruitInfo = {
  title: "STAFF RECRUITMENT",
  subtitle: "スタッフ募集",
  positions: [
    {
      title: "ホールスタッフ",
      type: "アルバイト・パート",
      wage: "時給1,500円〜3,000円",
      benefits: ["未経験OK", "体験入店OK", "髪型・服装自由", "まかない付き", "交通費支給"],
      hours: "20:00〜25:00（シフト制）",
    },
  ],
  message:
    "お酒が好きな方、人と話すことが好きな方、大歓迎です。\n経験の有無は問いません。まずは体験入店から、気軽に始めてみませんか？",
  contact: "お電話またはInstagram DMにてご応募ください",
};

export const imageUrls = {
  hero: "/images/db879da9d054ad5001ed1969c2582bcb.jpg",
  concept: "/images/lounge-seating.png",
  interior: "/images/lounge-entrance.png",
  staff: "/images/lounge-counter.png",
  store: "/images/store.png",
  store02: "/images/store02.png",
};
